import request, { ApiResponse } from './request';
import { WineCategory } from '@/types';

export interface CategoryWithLevels extends WineCategory {
  priceLevels: any[];
}

export interface CategoryFormData {
  name: string;
  icon?: string;
  sort_order?: number;
}

export function getCategories(): Promise<ApiResponse<CategoryWithLevels[]>> {
  return request.get('/categories');
}

export function createCategory(data: CategoryFormData): Promise<ApiResponse<CategoryWithLevels>> {
  return request.post('/categories', data);
}

export function updateCategory(id: number, data: CategoryFormData): Promise<ApiResponse<CategoryWithLevels>> {
  return request.put(`/categories/${id}`, data);
}

export function deleteCategory(id: number): Promise<ApiResponse<null>> {
  return request.delete(`/categories/${id}`);
}
